import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { StoreContext } from '../contexts/StoreContext';

/**
 * Компонент-слушатель изменения роутов
 * Передает текущий роут в MSTModelStore для управления подписками
 */
function RouteListener() {
    const location = useLocation();
    const rootStore = useContext(StoreContext);
    const { models } = rootStore;
    
    useEffect(() => {
        // Передаем текущий роут в MSTModelStore
        if (models && models.handleRouteChange) {
            models.handleRouteChange(location.pathname);
        }
    }, [location.pathname, models]);
    
    // Компонент не рендерит ничего
    return null;
}

export default RouteListener;